import { Component, OnInit} from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { UsuariosEditComponent } from '../usuarios-edit/usuarios-edit.component';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css'],
  providers:[
    { provide: MatDialogRef,useValue: {} }
  ]
})
export class UsuariosComponent implements OnInit {
  errMsg:any;
  loading:boolean=false;
  usrs:any=[];

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<UsuariosEditComponent>, public dialog: MatDialog) { }

  ngOnInit() {
    this.fnIniciar();
  }

  fnIniciar(){
    this.loading = true;
    this.dataService.getUsuarios('%').subscribe(
                      rows => {   
                              this.usrs = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnUsuariosCargados());
  }

  fnUsuariosCargados(){
    console.log(this.usrs)
  }

  fnEditar(user){
    //console.log("Editar: " + desc.id);
    let dialogRef = this.dialog.open(UsuariosEditComponent, {
                                      width: "600px",
                                      data: { 
                                            id:user.idPersona,
                                            item:user
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                    console.log("Popup cerrado");
                                    this.fnIniciar();
                                    }); 
  }

  fnNuevo(){
    //console.log("Ingresar nuevo item");
    let dialogRef = this.dialog.open(UsuariosEditComponent, {
                                      width: "600px",
                                      data: { 
                                            id:-1,
                                            item:{'desceunto': null,
                                                  'descrip': null,
                                                  'mon_por': '%',
                                                  'valor': null,
                                                  'act':1
                                                 }
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                    console.log("Popup cerrado");
                                    this.fnIniciar();
                                    }); 
  }

}
